import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-error-file',
  templateUrl: './error-file.component.html',
  styleUrls: ['./error-file.component.scss']
})
export class ErrorFileComponent implements OnInit {

  extensionFile = this.data.nameFile;
  correctExt = this.data.correctExtension;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { nameFile: string, correctExtension: string }
  ) { }

  ngOnInit(): void {
  }

}
